module.exports = __webpack_public_path__ + "static/media/apartment14.a4e0c838.jpg";